const config = [
  {
    component: 'ZlmTitle',
    options: {
      size: 'medium',
      text: '集中采购详情',
    },
  },
  {
    component: 'ZlmNormalDetail',
    options: {
      data: {},
    },
  },
  {
    component: 'ZlmTitle',
    options: {
      size: 'medium',
      text: '集中采购计划附件',
    },
  },
  {
    component: 'file-list',
    options: {
      groupId: '',
    },
  },
  {
    component: 'ZlmTitle',
    options: {
      size: 'medium',
      text: '采购计划信息',
    },
  },
  {
    component: 'ZlmTabDetail',
    options: {
      title: '计划',
      data: [],
    },
  },
  {
    component: 'ZlmTitle',
    options: {
      size: 'medium',
      text: '计划审核流程',
    },
  },
  {
    component: 'ZlmTabDetail',
    options: {
      title: '流程',
      data: [], // 7
    },
  },

]

const mixin = {
  data() {
    return {
      config: JSON.parse(JSON.stringify(config)),
      details: {},
      leibeiArr: [],
    }
  },
  methods: {
    getData() {
      this.getBaseInfo()
    },
    getBaseInfo() {
      const guid = this.$route.query.id
      // const guid = this.form.businessKey.split(':')[1]
      this.$request
        .post(
          `/transformToAfter/app/central/purchase/getDetail`,
          {
            guid: guid,
          },
          { showLoading: true },
        )
        .then((res) => {
          this.details = res.data
          this.config[3].options.groupId = res.data.jiHuaFuJian
          this.config[1].options.data = {
            集中采购计划名称: res.data.caigouName,
            集中采购计划编号: res.data.caigouBh,
            计划招标时间: this.$util.timeFormatter(
              res.data.planProcurementTime,
            ),
            计划开工时间: this.$util.timeFormatter(
              res.data.startOrDeliveryTime,
            ),
            '项目估算（万元）': res.data.estimatedAmount,
            '工期/服务期（月）': res.data.gongQi,
            项目计划级别: res.data.jiHuaJiBie === 1 ? '一般项目' : '重大项目',
            行业: this.getHangYe(res.data.hangYe),
            // '类别': '',
            // '集中采购计划附件': 'res.data.jiHuaFuJian',
            项目概况: res.data.remark,
            // 采购计划添加: '',
            变更说明: res.data.chongxinTiJiaoExplain,
          }
          if (res.data.chongxinTiJiaoExplain === '') {
            delete this.config[1].options.data.变更说明
          }
          console.log(res.data.list)
          this.config[5].options.data = res.data.list.map((t) => ({
            招采计划名称: t.projectName,
            招采计划编号: t.projectNo,
            类别: this.getLeiBie(t.yiJiFenLei, t.erJiFenLei, t.sanJiFenLei),
            // 二级分类: this.getFenLei(t.erJiFenLei),
            // 三级分类: this.getFenLei(t.sanJiFenLei),
            计划创建单位: t.tibaoDepartment,
            招标开始时间: this.$util.timeFormatter(t.createdTime),
            '项目估算（万元）': t.estimatedAmount,
          }))
          this.config[7].options.data = res.data.shenherenList.map(
            (t) => ({
              审核级别: t.level,
              审核人员: t.userName,
              单位部门: t.qiyeName + '--' + t.deptName,
            }),
          )
        })
    },
    getAuditList() {
      this.$request
        .post(
          `/transformToAfter/app/project/sign/getRecord`,
          {
            guid: this.$route.query.id,
            businessType: 4,
          },
        )
        .then((res) => {
          if (res.data && res.data.length > 0) {
            this.config[9].options.data = res.data.map(
              (t) => ({
                提交人: t.submitter,
                提交时间: this.$util.timeFormatter(t.submitTime),
                审批人: t.auditName,
                审批结果: this.getShenHeJieGuo(t.statusMsg),
                审核时间: this.$util.timeFormatter(t.auditTime),
                审批意见: t.auditOpinion,
              }),
            )
          }
        })
    },
    // 审核结果
    getShenHeJieGuo(type) {
      let result = ''
      switch (type) {
        case 0:
          result = '未审批'
          break
        case 1:
          result = '审批通过'
          break
        case 2:
          result = '审批驳回'
          break
        case 3:
          result = '流程撤回'
          break
        default:
          break
      }
      return result
    },
    getFenLei(val) {
      switch (val) {
        case 0:
          return '工程'
        case 1:
          return '货物'
        case 2:
          return '服务'
        case 11:
          return '主线土建工程'
        case 14:
          return '养护工程'
        case 16:
          return '施工'
        case 21:
          return '标准材料采购'
        case 22:
          return '设备采购安装'
        case 23:
          return '车辆（设备）采购'
        case 31:
          return '勘察设计'
        case 32:
          return '施工监理'
        case 33:
          return '试验检测'
        case 34:
          return '监理'
        case 35:
          return '信息化服务'
        case 36:
          return '科技咨询服务'
        case 99:
          return '其他'

        default:
          break
      }
    },
    getLeiBie(yiji, erji, sanji) {
      const projectTypeJC = [
        {
            code: 0,
            name: '工程',
            children: [
                {
                    code: 11,
                    name: '养护类',
                    children: [
                        { code: 111, name: '路段日常维护' },
                        { code: 112, name: '路段专项养护' },
                        { code: 113, name: '路面专项养护' },
                        { code: 114, name: '机电日常维护' },
                        { code: 115, name: '机电专项改造' },
                    ],
                },
                { code: 12, name: '房屋维修', children: [{ code: 121, name: '工程-房屋维修类-办公、生产生活类房屋维修（含装饰装修）' }] },
            ],
        },
        {
            code: 1,
            name: '货物',
            children: [
                { code: 21, name: '高速公路建设材料', children: [{ code: 211, name: '钢材及其制品、水泥、沥青' }] },
                {
                    code: 22,
                    name: '交安机电产品',
                    children: [
                        { code: 221, name: '交通安全设施、消防器材及配件' },
                        { code: 222, name: '机电备品备件、通用电子设备、通用软件、工作软件' },
                    ],
                },
                { code: 23, name: '房建材料', children: [{ code: 231, name: '装饰装修及电气材料' }] },
                { code: 24, name: '房地产设备设施', children: [{ code: 241, name: '电梯、机械车位等' }] },
                {
                    code: 25,
                    name: '经营管理类设备材料',
                    children: [
                        { code: 251, name: '客车、货车' },
                        { code: 252, name: '各类机械设备及通用零配件' },
                        { code: 253, name: '融雪剂等材料' },
                        { code: 254, name: '办公生活家具、电器、厨具、办公耗材等' },
                        { code: 255, name: '职工福利劳保用品' },
                    ],
                },
            ],
        },
        {
            code: 2,
            name: '服务',
            children: [
                {
                    code: 31,
                    name: '建设服务',
                    children: [
                        { code: 311, name: '交工检测、环保监测、水土保持监测等检测咨询' },
                        { code: 312, name: '档案咨询' },
                    ],
                },
                {
                    code: 32,
                    name: '其他服务',
                    children: [
                        { code: 321, name: '营运各类检测咨询' },
                        { code: 322, name: '运输、仓储物流一体化及其配送等' },
                        { code: 323, name: '道路救援、车辆维修' },
                        { code: 324, name: '车辆租赁、通勤车等' },
                        { code: 325, name: '广告、宣传类传媒制作及活动承办' },
                        { code: 326, name: '建筑单体或零星设计项目' },
                    ],
                },
                {
                    code: 33,
                    name: '保险服务',
                    children: [{ code: 331, name: '工程保险、车辆设备保险、财产保险、人身保险、责任保险等保险类' }],
                },
            ],
        },
        {
            code: 3,
            name: '其他',
            children: [
                { code: 34, name: '其他', children: [{ code: 99, name: '其他' }] },
            ],
        },
    ]

    projectTypeJC.forEach((item) => {
      if (item.code === yiji) {
        this.leibeiArr.push(item.name)
        this.recursion(item.children, erji, sanji)
      }
    })
    return this.leibeiArr.join()
    },
    recursion(val, code, sanji) {
        val.forEach((item) => {
          if (item.code === code) {
            this.leibeiArr.push(item.name)
            console.log(this.leibeiArr)
            if (item.children) {
              this.recursion(item.children, sanji)
            }
          }
        })
    },
    pass() {
      this.planReportApprove({
        planId: this.$route.query.id,
        remark: '',
        status: 1,
      })
      // this.commit()
    },
    fail(opinion) {
      this.planReportApprove({
        planId: this.$route.query.id,
        remark: opinion,
        status: 2,
      })
      // this.commit({
      //     opValue: '2', // 不通过
      //     opinion: opinion,
      // })
    },
    // 行业 1、交通运输 2、房地产 3、金融
    getHangYe(type) {
      let result = '交通运输'
      switch (type) {
        case 1:
          result = '交通运输'
          break
        case 2:
          result = '房地产'
          break
        case 3:
          result = '金融'
          break
        default:
          break
      }
      return result
    },

  },
}

module.exports = {
  config,
  mixin,
}
